<div class="tooltip" data-testid="input-editor-tooltip" [ngClass]="{'warning-msg':isWarning()}">
    <div class="tooltip-content">
        <div>{{ message() }}</div>
        <div class="icon-wrapper">
            <img class="error-icon" [src]="isWarning() ? '/images/warning.svg' : '/images/notification2.svg'"
                [alt]="iconAlt()" />
        </div>
    </div>
</div>